export const ScrollClasses = {
  scrollDrag: 'scroll-drag',
};
